<template>
  <div class="batch_order_new">
    <FinButton v-for="(item, index) in menuLeftOption" :key="index" v-bind="item" class="special_btn"></FinButton>
    <div class="search_contain">
      <label style="line-height: 32px; color: #666">{{ $lang('客户订单号') }}：</label>
      <el-input clearable v-model="formCustomerOrderId" :placeholder="$lang('请输入客户订单号')" maxlength="30" style="margin-right: 10px; width: 212px !important"></el-input>
      <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange" :loading="searchLoading">{{ $lang('查询') }} </el-button>
      <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }} </el-button>
      <el-button type="primary" @click="setOrder" :loading="keyBtn" :disabled="tabActive === 1 || keyBtn || !multipleSelection.length ? true : false" class="setOrder h48">
        {{ keyBtn ? $lang('下单中...') : $lang('立即下单') }}
      </el-button>
    </div>
    <div class="middle_contain">
      <el-alert type="success" center v-if="showBulkResult" @close="closeAlert">
        <div v-if="errorLength === 0">
          {{ $lang('本次共提交') }}{{ allLength }}{{ $lang('条订单') }}，{{ successLength }}{{ $lang('条成功') }}，{{ errorLength }}{{ $lang('条提交失败') }}。
        </div>
        <div v-else>
          {{ $lang('本次共提交') }}{{ allLength }}{{ $lang('条订单') }}，{{ successLength }}{{ $lang('条成功') }}，{{ errorLength }}{{ $lang('条失败，请重新提交失败的订单') }}。
        </div>
      </el-alert>
      <el-alert type="success" center v-if="showImportResult" @close="closeAlert">
        <div>{{ $lang('本次共导入') }}{{ leadAllLength }}{{ $lang('条数据') }}，{{ successList.length }}{{ $lang('条成功') }}，{{ failList.length }}{{ $lang('条失败') }}。</div>
      </el-alert>
      <div class="tabs">
        <div :class="{ active: tabActive === 0 }" @click="handleClick(0)"><i class="iconfont iconchenggong"></i>{{ $lang('导入成功') }}</div>
        <div :class="{ active: tabActive === 1 }" @click="handleClick(1)" style="margin-left: 10px"><i class="iconfont iconshibai"></i>{{ $lang('导入失败') }}</div>
      </div>
      <table-index
        v-if="tabActive === 0"
        :table-list="successList"
        @selectChange="selectChange"
        @rowEditTable="(row) => editHandleSuccess(row, 1)"
        :tabActive="tabActive"
      ></table-index>
      <table-index v-else-if="tabActive === 1" :table-list="failList" @selectChange="selectChange" @rowEditTable="(row) => editHandle(row, 2)" :tabActive="tabActive"></table-index>
    </div>
    <upload-file @success="uploadSuccess" ref="uploadFile" :upload-url="this.COM_HTTP.importFile"></upload-file>
    <edit-form @edit-save="updateSingleOrder" ref="editForm" :rowResult="rowResult"></edit-form>
    <edit-order ref="editOrder" :orderData="rowSuccess" @edit-success-save="updateSingleOrder"></edit-order>
  </div>
</template>
<script>
import FinButton from '@components/fin-button/index.vue'
import TableIndex from './components/tableIndex.vue'
import UploadFile from '@components/upload-file/index.vue'
import mixin from './mixin'
import { batchOrderNew } from './pool'
import editForm from './components/editForm.vue'
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import EditOrder from './components/EditOrder.vue'

export default {
  name: 'BatchOrderNew',
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: batchOrderNew,
      tabActive: 0,
      formCustomerOrderId: null,
      failList: [],
      successList: [],
      showBulkResult: false,
      showImportResult: false,
      originList: [],
      keyBtn: false,
      searchLoading: false,
      rowResult: {},
      editDialogVisible: false,
    }
  },
  components: {
    FinButton,
    TableIndex,
    UploadFile,
    editForm,
    EditOrder,
  },
  computed: {
    ...mapState({
      countryList: (state) => state.base.countryList,
    }),
    menuLeftOption() {
      const list = [
        {
          title: '批量导入',
          icon: 'icondaoru',
          click: this.handleImport,
        },
        {
          title: '下载模版',
          icon: 'iconxiazai',
          clickOnLoading: (loading) => {
            this.downLoadTemplate(loading, 3)
          },
        },
        {
          title: '删除',
          icon: 'iconshanchu',
          disabled: this.keyBtn || this.multipleSelection.length < 1,
          clickOnLoading: (loading) => {
            this.deleteHandle(loading)
          },
        },
      ]
      return list
    },
  },
  methods: {
    handleClick(index) {
      this.tabActive = index
      this.multipleSelection = []
      if (index === 0) {
        this.originList = cloneDeep(this.successList)
      } else if (index === 1) {
        this.originList = cloneDeep(this.failList)
      }
      this.isSelectAll = false
      setTimeout(() => {
        this.$bus.$emit('doLayout')
      }, 20)
    },
    handleImport() {
      this.$refs.uploadFile.open()
    },
    uploadSuccess(data, type) {
      this.showImportResult = true
      this.showBulkResult = false
      const successList = data.data.success || []
      const failList = data.data.fail || []
      this.successList = successList.map((i, index) => {
        return {
          ...i,
          id: String(Date.now() + Math.random().toString(36)),
        }
      })
      this.failList = failList.map((k, index2) => {
        return {
          ...k,
          id: String(Date.now() + Math.random().toString(36)),
        }
      })
      this.leadAllLength = successList.length + failList.length
      if (this.failList.length > 0) {
        this.tabActive = 1
        this.originList = this.failList
      } else {
        this.tabActive = 0
        this.originList = this.successList
      }
      this.multipleSelection = []
    },
    async downLoadTemplate(loading, type) {
      const params = { type }
      const downFormData = new FormData()
      Object.keys(params).forEach((key) => {
        downFormData.append(key, params[key])
      })
      const res = await this.COM_HTTP.downLoadFile()
      loading && loading()
      if (res) {
        const enc = new TextDecoder('utf-8')
        let errorData = { code: null }
        try {
          errorData = JSON.parse(enc.decode(new Uint8Array(res)))
        } catch (error) {
          console.log('eror', error)
        }
        if (errorData.code) {
          this.$message.error(errorData.msg)
        } else {
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            const name = this.$lang('DHL下载模板')
            window.navigator.msSaveOrOpenBlob(res, `${name}.xls`)
          } else {
            const url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' }))
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = url
            const name = this.$lang('DHL下载模板')
            elink.setAttribute('download', `${name}.xls`)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          }
        }
      }
    },
    deleteHandle(loading) {
      const formIndexArray = this.multipleSelection.map((i) => i.id)
      const originArray = []
      this.originList.forEach((originListItem) => {
        if (formIndexArray.indexOf(originListItem.id) < 0) {
          originArray.push(originListItem)
        }
      })
      this.multipleSelection = []
      if (this.tabActive === 0) {
        this.successList = originArray
        loading && loading()
      } else if (this.tabActive === 1) {
        this.failList = originArray
        loading && loading()
      }
      this.originList = originArray
    },
    searchChange() {
      const { successList, failList, tabActive, formCustomerOrderId } = this
      const sourceArr = [successList, failList]
      if (!this.formCustomerOrderId) {
        if (this.tabActive === 0) {
          this.successList = sourceArr[tabActive]
        } else {
          this.failList = sourceArr[tabActive]
        }
        return
      }
      if (tabActive === 0 && successList.length) {
        this.successList = successList.filter((item) => item.customerOrderId === formCustomerOrderId)
      }
      if (tabActive === 1 && failList.length) {
        this.failList = failList.filter((item) => item.customerOrderId === formCustomerOrderId)
      }
    },
    resetSearch() {
      this.formCustomerOrderId = null
    },
    closeAlert() {
      this.showBulkResult = false
      this.showImportResult = false
    },
  },
}
</script>
<style scoped lang="scss">
.batch_order_new {
  margin: 20px;
  .search_contain {
    margin: 20px 0;
    .setOrder {
      float: right;
    }
  }
  ::v-deep {
    .special_btn {
      height: 40px !important;
      padding: 0 23px !important;
      span {
        font-size: 16px !important;
      }
    }
    .special_btn:nth-child(1) {
      background-color: red;
      color: #ffffff;
    }
    .is-disabled {
      border-color: #ddd;
      color: #999999;
      background: #edeef3;
    }
  }
  .tabs {
    height: 39px;
    div {
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      border: 1px solid #dcdfe6;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 14px;
      background: #e0e1e7;
      height: 40px;
      border: 0;
      background: #e0e1e7;
      border-radius: 8px 8px 0 0;
      color: #666;
      i {
        margin-right: 8px;
        color: #666;
      }
      &.active {
        background: #fff;
        color: #e60012;
        i {
          color: #e60012;
        }
      }
    }
  }
}
</style>
